var map = {
	"./Banner.png": 1794,
	"./add-button.svg": 1795,
	"./add-text-button.svg": 1796,
	"./banner-bubbles.png": 1797,
	"./banner-circle-bg.png": 1798,
	"./congrats.png": 1799,
	"./fonts/Vazir-Black.eot": 1800,
	"./fonts/Vazir-Black.ttf": 1801,
	"./fonts/Vazir-Black.woff": 1802,
	"./fonts/Vazir-Black.woff2": 1803,
	"./fonts/Vazir-Bold.eot": 1804,
	"./fonts/Vazir-Bold.ttf": 763,
	"./fonts/Vazir-Bold.woff": 1805,
	"./fonts/Vazir-Bold.woff2": 1806,
	"./fonts/Vazir-Light.eot": 1807,
	"./fonts/Vazir-Light.ttf": 764,
	"./fonts/Vazir-Light.woff": 1808,
	"./fonts/Vazir-Light.woff2": 1809,
	"./fonts/Vazir-Medium.eot": 1810,
	"./fonts/Vazir-Medium.ttf": 765,
	"./fonts/Vazir-Medium.woff": 1811,
	"./fonts/Vazir-Medium.woff2": 1812,
	"./fonts/Vazir-Thin.eot": 1813,
	"./fonts/Vazir-Thin.ttf": 1814,
	"./fonts/Vazir-Thin.woff": 1815,
	"./fonts/Vazir-Thin.woff2": 1816,
	"./fonts/Vazir.eot": 1817,
	"./fonts/Vazir.ttf": 766,
	"./fonts/Vazir.woff": 1818,
	"./fonts/Vazir.woff2": 1819,
	"./fonts/icons-font.ttf": 767,
	"./gift.png": 617,
	"./gift.svg": 477,
	"./icons/Circle.png": 1820,
	"./icons/Circle.svg": 1821,
	"./icons/CircleLine.png": 1822,
	"./icons/CircleLine.svg": 1823,
	"./icons/FavLocationGreen.svg": 1824,
	"./icons/FavLocationYellow.png": 1825,
	"./icons/FavLocationYellowWeb.svg": 1826,
	"./icons/Icon24-FavLocation-Green.png": 1827,
	"./icons/Icon24-Time-Green.png": 1828,
	"./icons/Icon24-Time-yellow.png": 1829,
	"./icons/Time.svg": 1830,
	"./icons/TimeYellow.svg": 1831,
	"./icons/activeDot.png": 653,
	"./icons/activeDot.svg": 513,
	"./icons/appInfo.png": 659,
	"./icons/appInfo.svg": 519,
	"./icons/avatar.png": 666,
	"./icons/avatar.svg": 526,
	"./icons/bag-shoe.png": 1832,
	"./icons/basket/android/ordersBasket.png": 635,
	"./icons/basket/android/receipt.png": 636,
	"./icons/basket/android/truck.png": 633,
	"./icons/basket/web/ordersBasket.svg": 495,
	"./icons/basket/web/receipt.svg": 496,
	"./icons/basket/web/truck.svg": 493,
	"./icons/bottomNavigation/android/homeActive.png": 660,
	"./icons/bottomNavigation/android/homeDefault.png": 663,
	"./icons/bottomNavigation/android/ordersActive.png": 661,
	"./icons/bottomNavigation/android/ordersDefault.png": 664,
	"./icons/bottomNavigation/android/profileActive.png": 662,
	"./icons/bottomNavigation/android/profileDefault.png": 665,
	"./icons/bottomNavigation/web/homeActive.svg": 520,
	"./icons/bottomNavigation/web/homeDefault.svg": 523,
	"./icons/bottomNavigation/web/ordersActive.svg": 521,
	"./icons/bottomNavigation/web/ordersDefault.svg": 524,
	"./icons/bottomNavigation/web/profileActive.svg": 522,
	"./icons/bottomNavigation/web/profileDefault.svg": 525,
	"./icons/categories/android/bed.png": 527,
	"./icons/categories/android/children.png": 528,
	"./icons/categories/android/curtain.png": 529,
	"./icons/categories/android/home.png": 530,
	"./icons/categories/android/jackets.png": 531,
	"./icons/categories/android/men.png": 532,
	"./icons/categories/android/mensDress.png": 1833,
	"./icons/categories/android/misc.png": 533,
	"./icons/categories/android/shoes.png": 534,
	"./icons/categories/android/sleepProducts.png": 1834,
	"./icons/categories/android/women.png": 535,
	"./icons/categories/web/bed.svg": 387,
	"./icons/categories/web/children.svg": 388,
	"./icons/categories/web/curtain.svg": 389,
	"./icons/categories/web/home.svg": 390,
	"./icons/categories/web/jackets.svg": 391,
	"./icons/categories/web/men.svg": 392,
	"./icons/categories/web/misc.svg": 393,
	"./icons/categories/web/shoes.svg": 394,
	"./icons/categories/web/women.svg": 395,
	"./icons/children.png": 1835,
	"./icons/curtain.png": 1836,
	"./icons/delete.png": 639,
	"./icons/delete.svg": 499,
	"./icons/dot.png": 652,
	"./icons/dot.svg": 512,
	"./icons/editPrice.png": 656,
	"./icons/editPrice.svg": 516,
	"./icons/emptyAddressesList.png": 641,
	"./icons/emptyAddressesList.svg": 501,
	"./icons/errors/android/ordersEmpty.png": 545,
	"./icons/errors/android/serverError.png": 544,
	"./icons/errors/web/ordersEmpty.svg": 405,
	"./icons/errors/web/serverError.svg": 404,
	"./icons/featured.png": 651,
	"./icons/featured.svg": 511,
	"./icons/gown.png": 1837,
	"./icons/hanger.png": 1838,
	"./icons/infoRounded.png": 619,
	"./icons/infoRounded.svg": 479,
	"./icons/jackets.png": 1839,
	"./icons/ladies.png": 1840,
	"./icons/logisticGray.png": 624,
	"./icons/logisticGray.svg": 488,
	"./icons/logisticGrayLeft.png": 625,
	"./icons/logisticGrayLeft.svg": 489,
	"./icons/logisticGreen.png": 626,
	"./icons/logisticGreen.svg": 490,
	"./icons/logisticGreenLeft.png": 627,
	"./icons/logisticGreenLeft.svg": 491,
	"./icons/logisticOrangeLeft.png": 622,
	"./icons/logisticOrangeLeft.svg": 482,
	"./icons/logisticOrangeRight.png": 621,
	"./icons/logisticOrangeRight.svg": 481,
	"./icons/logisticRedRight.png": 623,
	"./icons/logisticRedRight.svg": 483,
	"./icons/logisticTime.png": 654,
	"./icons/logisticTime.svg": 514,
	"./icons/logisticYellowLeft.png": 628,
	"./icons/logisticYellowLeft.svg": 492,
	"./icons/logisticYellowRight.png": 620,
	"./icons/logisticYellowRight.svg": 480,
	"./icons/more.png": 638,
	"./icons/more.svg": 498,
	"./icons/orderBasket.png": 616,
	"./icons/orderBasket.svg": 476,
	"./icons/orderOnProgress.png": 634,
	"./icons/orderOnProgress.svg": 494,
	"./icons/other.png": 1841,
	"./icons/pants.png": 1842,
	"./icons/personal.png": 637,
	"./icons/personal.svg": 497,
	"./icons/play.png": 657,
	"./icons/play.svg": 517,
	"./icons/products/android/WomenTrousersAndroid.png": 1843,
	"./icons/products/android/add.png": 542,
	"./icons/products/android/addDisabled.png": 543,
	"./icons/products/android/babySeat.png": 558,
	"./icons/products/android/babyShoes.png": 556,
	"./icons/products/android/backPack.png": 587,
	"./icons/products/android/bag.png": 588,
	"./icons/products/android/bathrobes.png": 580,
	"./icons/products/android/blanket.png": 575,
	"./icons/products/android/boot.png": 585,
	"./icons/products/android/canopy.png": 552,
	"./icons/products/android/carCover.png": 553,
	"./icons/products/android/carpet.png": 570,
	"./icons/products/android/carriage.png": 557,
	"./icons/products/android/ceremonyMantoo.png": 603,
	"./icons/products/android/childClothes.png": 554,
	"./icons/products/android/cloak.png": 551,
	"./icons/products/android/coat.png": 562,
	"./icons/products/android/cover.png": 576,
	"./icons/products/android/cushion.png": 569,
	"./icons/products/android/doll.png": 555,
	"./icons/products/android/eiderdown.png": 577,
	"./icons/products/android/featherJacket.png": 563,
	"./icons/products/android/gloves.png": 546,
	"./icons/products/android/hat.png": 547,
	"./icons/products/android/iron.png": 537,
	"./icons/products/android/jacket.png": 561,
	"./icons/products/android/lampshade.png": 571,
	"./icons/products/android/leatherShoes.png": 586,
	"./icons/products/android/loggage.png": 589,
	"./icons/products/android/mat.png": 573,
	"./icons/products/android/mattress.png": 574,
	"./icons/products/android/menBluze.png": 590,
	"./icons/products/android/menCoat.png": 591,
	"./icons/products/android/menCoatTrousers.png": 612,
	"./icons/products/android/menCoatWest.png": 610,
	"./icons/products/android/menShortTrousers.png": 595,
	"./icons/products/android/menTie.png": 596,
	"./icons/products/android/menTrousers.png": 592,
	"./icons/products/android/menTshirt.png": 593,
	"./icons/products/android/minus.png": 540,
	"./icons/products/android/minusDisabled.png": 541,
	"./icons/products/android/overcoat.png": 564,
	"./icons/products/android/pillow.png": 578,
	"./icons/products/android/pillowCover.png": 579,
	"./icons/products/android/pray.png": 550,
	"./icons/products/android/pullOver.png": 567,
	"./icons/products/android/rainCoat.png": 566,
	"./icons/products/android/semmershoes.png": 584,
	"./icons/products/android/shawl.png": 549,
	"./icons/products/android/shoes2.png": 583,
	"./icons/products/android/skiJacket.png": 560,
	"./icons/products/android/skipants.png": 565,
	"./icons/products/android/sleepingBag.png": 581,
	"./icons/products/android/socks.png": 548,
	"./icons/products/android/stainRemover.png": 538,
	"./icons/products/android/sweatShirt.png": 568,
	"./icons/products/android/tableclothes.png": 572,
	"./icons/products/android/towel.png": 582,
	"./icons/products/android/wash.png": 536,
	"./icons/products/android/womenCeremonyDress.png": 599,
	"./icons/products/android/womenCoat.png": 597,
	"./icons/products/android/womenCoatSkirt.png": 611,
	"./icons/products/android/womenCoatTrousers.png": 609,
	"./icons/products/android/womenCover.png": 594,
	"./icons/products/android/womenDress.png": 598,
	"./icons/products/android/womenHijab.png": 606,
	"./icons/products/android/womenLongHijab.png": 608,
	"./icons/products/android/womenMantoo.png": 602,
	"./icons/products/android/womenShomiz.png": 1844,
	"./icons/products/android/womenShomizSkirt.png": 613,
	"./icons/products/android/womenShomizTop.png": 614,
	"./icons/products/android/womenShortTrousers.png": 607,
	"./icons/products/android/womenSkirt.png": 604,
	"./icons/products/android/womenTop.png": 1845,
	"./icons/products/android/womenTrousers.png": 600,
	"./icons/products/android/womenTshirt.png": 605,
	"./icons/products/android/womenWeddingDress.png": 601,
	"./icons/products/android/womenWinterClothes.png": 615,
	"./icons/products/android/‌babyClothes.png": 559,
	"./icons/products/web/add.svg": 402,
	"./icons/products/web/addDisabled.svg": 403,
	"./icons/products/web/babyClothes.svg": 419,
	"./icons/products/web/babySeat.svg": 418,
	"./icons/products/web/babyShoes.svg": 416,
	"./icons/products/web/backPack.svg": 447,
	"./icons/products/web/bag.svg": 448,
	"./icons/products/web/bathrobes.svg": 440,
	"./icons/products/web/blanket.svg": 435,
	"./icons/products/web/boot.svg": 445,
	"./icons/products/web/canopy.svg": 412,
	"./icons/products/web/carCover.svg": 413,
	"./icons/products/web/carpet.svg": 430,
	"./icons/products/web/carriage.svg": 417,
	"./icons/products/web/ceremonyMantoo.svg": 463,
	"./icons/products/web/childClothes.svg": 414,
	"./icons/products/web/cloak.svg": 411,
	"./icons/products/web/coat.svg": 422,
	"./icons/products/web/cover.svg": 436,
	"./icons/products/web/cushion.svg": 429,
	"./icons/products/web/doll.svg": 415,
	"./icons/products/web/eiderdown.svg": 437,
	"./icons/products/web/featherJacket.svg": 423,
	"./icons/products/web/gloves.svg": 406,
	"./icons/products/web/hat.svg": 407,
	"./icons/products/web/iron.svg": 397,
	"./icons/products/web/jacket.svg": 421,
	"./icons/products/web/lampshade.svg": 431,
	"./icons/products/web/leatherShoes.svg": 446,
	"./icons/products/web/loggage.svg": 449,
	"./icons/products/web/mat.svg": 433,
	"./icons/products/web/mattress.svg": 434,
	"./icons/products/web/menBluze.svg": 450,
	"./icons/products/web/menCoat.svg": 451,
	"./icons/products/web/menCoatTrousers.svg": 472,
	"./icons/products/web/menCoatWest.svg": 470,
	"./icons/products/web/menShortTrousers.svg": 455,
	"./icons/products/web/menTie.svg": 456,
	"./icons/products/web/menTrousers.svg": 452,
	"./icons/products/web/menTshirt.svg": 453,
	"./icons/products/web/minus.svg": 400,
	"./icons/products/web/minusDisabled.svg": 401,
	"./icons/products/web/overcoat.svg": 424,
	"./icons/products/web/pillow.svg": 438,
	"./icons/products/web/pillowCover.svg": 439,
	"./icons/products/web/pray.svg": 410,
	"./icons/products/web/pullOver.svg": 427,
	"./icons/products/web/rainCoat.svg": 426,
	"./icons/products/web/semmershoes.svg": 444,
	"./icons/products/web/shawl.svg": 409,
	"./icons/products/web/shoes2.svg": 443,
	"./icons/products/web/skiJacket.svg": 420,
	"./icons/products/web/skipants.svg": 425,
	"./icons/products/web/sleepingBag.svg": 441,
	"./icons/products/web/socks.svg": 408,
	"./icons/products/web/stainRemover.svg": 398,
	"./icons/products/web/sweatShirt.svg": 428,
	"./icons/products/web/tableclothes.svg": 432,
	"./icons/products/web/towel.svg": 442,
	"./icons/products/web/wash.svg": 396,
	"./icons/products/web/womenCeremonyDress.svg": 459,
	"./icons/products/web/womenCoat.svg": 457,
	"./icons/products/web/womenCoatSkirt.svg": 471,
	"./icons/products/web/womenCoatTrousers.svg": 469,
	"./icons/products/web/womenCover.svg": 454,
	"./icons/products/web/womenDress.svg": 458,
	"./icons/products/web/womenHijab.svg": 466,
	"./icons/products/web/womenLongHijab.svg": 468,
	"./icons/products/web/womenMantoo.svg": 462,
	"./icons/products/web/womenShomiz.svg": 1846,
	"./icons/products/web/womenShomizSkirt.svg": 473,
	"./icons/products/web/womenShomizTop.svg": 474,
	"./icons/products/web/womenShortTrousers.svg": 467,
	"./icons/products/web/womenSkirt.svg": 464,
	"./icons/products/web/womenTop.svg": 1847,
	"./icons/products/web/womenTrousers.svg": 460,
	"./icons/products/web/womenTshirt.svg": 465,
	"./icons/products/web/womenWeddingDress.svg": 461,
	"./icons/products/web/womenWinterClothes.svg": 475,
	"./icons/profile/android/appVersion.png": 649,
	"./icons/profile/android/call.png": 647,
	"./icons/profile/android/info.png": 648,
	"./icons/profile/android/invitation.png": 646,
	"./icons/profile/android/location.png": 644,
	"./icons/profile/android/logOut.png": 655,
	"./icons/profile/android/payment.png": 645,
	"./icons/profile/android/terms.png": 650,
	"./icons/profile/web/appVersion.svg": 509,
	"./icons/profile/web/call.svg": 507,
	"./icons/profile/web/info.svg": 508,
	"./icons/profile/web/invitation.svg": 506,
	"./icons/profile/web/location.svg": 504,
	"./icons/profile/web/logOut.svg": 515,
	"./icons/profile/web/payment.svg": 505,
	"./icons/profile/web/terms.svg": 510,
	"./icons/pullover.png": 1848,
	"./icons/shade.png": 1849,
	"./icons/shirt.png": 1850,
	"./icons/sleep.png": 1851,
	"./icons/star.png": 642,
	"./icons/star.svg": 502,
	"./icons/subtract.png": 658,
	"./icons/subtract.svg": 518,
	"./icons/suit.png": 1852,
	"./icons/tailoring.png": 539,
	"./icons/tailoring.svg": 399,
	"./icons/veil.png": 1853,
	"./icons/warning.png": 640,
	"./icons/warning.svg": 500,
	"./icons/warningGreen.png": 643,
	"./icons/warningGreen.svg": 503,
	"./icons/washingMashin.png": 629,
	"./icons/washingMashin.svg": 484,
	"./icons/washingMashinGreen.png": 632,
	"./icons/washingMashinGreen.svg": 487,
	"./icons/washingMashinOrange.png": 631,
	"./icons/washingMashinOrange.svg": 486,
	"./icons/washingMashinYellow.png": 630,
	"./icons/washingMashinYellow.svg": 485,
	"./logo-symbol.svg": 1854,
	"./logo.png": 683,
	"./marker.png": 756,
	"./off-icon.png": 1855,
	"./orderBasket.png": 1856,
	"./orderBasket.svg": 1857,
	"./placeholder.jpg": 1858,
	"./placeholder.png": 1859,
	"./profile-picture.png": 170,
	"./share-button.svg": 1860,
	"./wallet.png": 618,
	"./wallet.svg": 478,
	"./warning-banner-bubbles.png": 1861,
	"./warning-banner-circle.png": 1862,
	"./wash-icon-warning-banner.png": 1863,
	"./wash-icon-warning-banner.svg": 1864,
	"./waveWeb.png": 1865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1793;